var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('page-tabs',{attrs:{"tabs":_vm.tabs}}),(_vm.activeTab === 'DADOS_PESSOAIS')?_c('dados-pessoais'):(_vm.activeTab === 'SEGURANCA')?_c('seguranca'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }